import { useTranslation } from 'react-i18next';
import { Button, cn } from '@bliks-io/ui';

/** "— oder — <add>": the manual row as the quiet alternative to an empty state's sources. */
export function OrAddManually({
  onAddManually,
  addLabelKey,
  className
}: {
  onAddManually: () => void;
  /** i18n key of the manual-add action, named after the entity */
  addLabelKey: string;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className={cn('text-center text-sm text-fg-secondary', className)}>
      — {t('common.or')} —{' '}
      <Button variant="link" type="button" className="h-auto" onClick={onAddManually}>
        {t(addLabelKey)}
      </Button>
    </div>
  );
}
